import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const GamepadIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 8h8a5 5 0 0 1 5 5v1.5a2.5 2.5 0 0 1-4.5 1.5L16 16H8l-.5.5A2.5 2.5 0 0 1 3 15v-2a5 5 0 0 1 5-5z" />
    <path d="M7 12v2M6 13h2" />
    <path d="M15.5 12.5v.01M17.5 14v.01" />
  </svg>
)
